import SimpleLightbox from "simplelightbox";
const initLightbox = () => {
    if(document.querySelector('.lightbox-item-wrapper')){
        new SimpleLightbox('.lightbox-item-wrapper a', { "overlayOpacity": 0.8, "captions": true });
    }
}
export default initLightbox;
